import { render, staticRenderFns } from "./OutboundAlertDuplicate.vue?vue&type=template&id=7b5a2336&scoped=true&"
import script from "./OutboundAlertDuplicate.vue?vue&type=script&lang=ts&"
export * from "./OutboundAlertDuplicate.vue?vue&type=script&lang=ts&"
import style0 from "./OutboundAlertDuplicate.vue?vue&type=style&index=0&id=7b5a2336&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5a2336",
  null
  
)

export default component.exports